export default "/8bf29ee963efcf8c93fa6fb6e90ffbb0.svg";